"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
var channel_1 = require("./channel");
/* BLUE */
function blue(color) {
    return channel_1.default(color, 'b');
}
/* EXPORT */
exports.default = blue;



//////////////////
// WEBPACK FOOTER
// ./~/khroma/dist/methods/blue.js
// module id = 2176
// module chunks = 0